import { useState, useRef, useCallback, useEffect } from "react";
import axios from "axios";
import { useDebouncedCallback } from "use-debounce";

export function useAutocompleteOptions({
  tipoRelacionamento
}) {
  const [autocompleteOptions, setAutocompleteOptions] = useState(null);
  const controllerRef = useRef();
  
  const onRequestOptions = useCallback(async (term) => {
    if(controllerRef.current) {
      controllerRef.current.abort();
    }

    controllerRef.current = new AbortController();

    if (!term || term.trim().length == 0) {
      setAutocompleteOptions([]);
      return;
    }

    try {
      const { data: options } = await axios.get(`/tipo-relatorios/autocomplete_relacionamento?tipo_relacionamento=${tipoRelacionamento}&term=${term}`, {
        signal: controllerRef.current.signal
      });

      setAutocompleteOptions(options?.map((op) => ({
        relacionamento_id: op.id,
        relacionamento_type: op.relacionamento_type,
        descricao: op.descricao,
        key: `${op.id}-${op.relacionamento_type}`,
      })));
      controllerRef.current = null;
    } catch (err) {
      controllerRef.current = null;
      if(axios.isCancel(err)) {
        return;
      }

      console.error(err);
      const message = err?.response?.message ?? "Houve um erro ao buscar os dados";
      setAutocompleteOptions([{
        id: null,
        message: message,
        error: true,
        key: 'error'
      }]);
    }
  }, [setAutocompleteOptions, tipoRelacionamento]);

  const onRequestOptionsDebounced = useDebouncedCallback(onRequestOptions, 500, {
    trailing: true,
    leading: false,
  });

  useEffect(() => {
    return () => {
      onRequestOptionsDebounced.cancel();
      controllerRef.current?.abort();
    }
  }, []);

  return {
    autocompleteOptions,
    setAutocompleteOptions,
    onRequestOptions: onRequestOptionsDebounced
  }
}